<template>
  <div class="row" style="padding-top: 250px">
    <div class="col-12" style="text-align: center">
      <p><strong>Thank you, this popup will close automatically!</strong></p>
      <div class="flex justify-center items-center q-pa-md">
        <QSpinner size="md" color="grey-7" />
      </div>
    </div>
  </div>
</template>

<script>
import { QSpinner } from 'quasar';
export default {
  name: 'QuoteSign',
  components: { QSpinner },
  data: function () {
    return {};
  },
  methods: {},
  async mounted() {
    setTimeout(() => {
      window.parent.document.getElementById('cancelButtonId').click();
    }, 4000);
  }
};
</script>
